(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if (typeof exports === 'object') exports["ReduxActionAnalytics"] = factory();else root["ReduxActionAnalytics"] = factory();
})(this, function () {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 0);
      /******/
    }(
    /************************************************************************/

    /******/
    [
    /* 0 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _v = __webpack_require__(1);

      var _v2 = _interopRequireDefault(_v);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var Analytics = function () {
        function Analytics(serverAddress, clientName) {
          var identifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
          var interval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 3200;
          var metadataAdder = arguments[4];

          _classCallCheck(this, Analytics);

          if (serverAddress === undefined) {
            throw new Error("Server address is not defined.");
          }

          if (clientName === undefined) {
            throw new Error("Client name is not defined.");
          }

          this.serverAddress = serverAddress;
          this.clientName = clientName;
          this.metadataAdder = metadataAdder;
          this.identifier = identifier;
          this.data = [];
          var send = this.send.bind(this);
          setInterval(send, interval);
          window.addEventListener("unload", send, false);
        }

        _createClass(Analytics, [{
          key: 'send',
          value: function send() {
            var _this = this;

            if (this.data.length === 0) {
              return;
            }

            var toSend = this.data;
            this.data = [];

            var data = this._prepareData(toSend);

            var xhr = new XMLHttpRequest();
            xhr.open("POST", this.serverAddress, true);
            xhr.setRequestHeader("Content-type", "application/json;charset=UTF-8");

            xhr.onreadystatechange = function () {
              if (xhr.readyState == XMLHttpRequest.DONE && xhr.status != 201) {
                _this.data = toSend.concat(_this.data);
              }
            };

            xhr.send(data);
          }
        }, {
          key: 'getMiddleware',
          value: function getMiddleware() {
            var _this2 = this;

            return function (store) {
              return function (next) {
                return function (action) {
                  var loggee = action;

                  if (typeof action === "function") {
                    loggee = {
                      type: "function " + action.name
                    };
                  }

                  _this2.saveAction(action);

                  next(action);
                };
              };
            };
          }
        }, {
          key: 'saveAction',
          value: function saveAction(action) {
            this.data.push({
              time: new Date().getTime(),
              action: action
            });
          }
        }, {
          key: '_onUnload',
          value: function _onUnload() {
            if (this.data.length === 0) {
              return;
            }

            var data = this._prepareData(this.data);

            if (navigator.sendBeacon) {
              navigator.sendBeacon(this.serverAddress, data);
            } else {
              var client = new XMLHttpRequest(); // Needs to be synchronous since the page is unloading

              client.open("POST", this.serverAddress, false);
              client.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
              client.send(data);
            }
          }
        }, {
          key: '_prepareData',
          value: function _prepareData(data) {
            var browser_identifier = localStorage['redux-id-75497'];

            if (browser_identifier === undefined) {
              browser_identifier = (0, _v2.default)();
              localStorage['redux-id-75497'] = browser_identifier;
            }

            var prepared = {
              data: data,
              client_name: this.clientName,
              site: document.location.origin,
              browser_identifier: browser_identifier,
              identifier: this.identifier
            };

            if (this.metadataAdder !== undefined) {
              var additionalMetadata = this.metadataAdder();
              prepared = Object.assign(prepared, additionalMetadata);
            }

            return JSON.stringify(prepared);
          }
        }]);

        return Analytics;
      }();

      exports.default = Analytics;
      /***/
    },
    /* 1 */

    /***/
    function (module, exports, __webpack_require__) {
      var rng = __webpack_require__(2);

      var bytesToUuid = __webpack_require__(4);

      function v4(options, buf, offset) {
        var i = buf && offset || 0;

        if (typeof options == 'string') {
          buf = options == 'binary' ? new Array(16) : null;
          options = null;
        }

        options = options || {};
        var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

        rnds[6] = rnds[6] & 0x0f | 0x40;
        rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

        if (buf) {
          for (var ii = 0; ii < 16; ++ii) {
            buf[i + ii] = rnds[ii];
          }
        }

        return buf || bytesToUuid(rnds);
      }

      module.exports = v4;
      /***/
    },
    /* 2 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (global) {
        // Unique ID creation requires a high quality random # generator.  In the
        // browser this is a little complicated due to unknown quality of Math.random()
        // and inconsistent support for the `crypto` API.  We do the best we can via
        // feature-detection
        var rng;
        var crypto = global.crypto || global.msCrypto; // for IE 11

        if (crypto && crypto.getRandomValues) {
          // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
          var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

          rng = function whatwgRNG() {
            crypto.getRandomValues(rnds8);
            return rnds8;
          };
        }

        if (!rng) {
          // Math.random()-based (RNG)
          //
          // If all else fails, use Math.random().  It's fast, but is of unspecified
          // quality.
          var rnds = new Array(16);

          rng = function rng() {
            for (var i = 0, r; i < 16; i++) {
              if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
              rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
            }

            return rnds;
          };
        }

        module.exports = rng;
        /* WEBPACK VAR INJECTION */
      }).call(exports, __webpack_require__(3));
      /***/
    },
    /* 3 */

    /***/
    function (module, exports) {
      var g; // This works in non-strict mode

      g = function () {
        return this;
      }();

      try {
        // This works if eval is allowed (see CSP)
        g = g || Function("return this")() || (1, eval)("this");
      } catch (e) {
        // This works if the window reference is available
        if (typeof window === "object") g = window;
      } // g can still be undefined, but nothing to do about it...
      // We return undefined, instead of nothing here, so it's
      // easier to handle this case. if(!global) { ...}


      module.exports = g;
      /***/
    },
    /* 4 */

    /***/
    function (module, exports) {
      /**
       * Convert array of 16 byte values to UUID string format of the form:
       * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
       */
      var byteToHex = [];

      for (var i = 0; i < 256; ++i) {
        byteToHex[i] = (i + 0x100).toString(16).substr(1);
      }

      function bytesToUuid(buf, offset) {
        var i = offset || 0;
        var bth = byteToHex;
        return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
      }

      module.exports = bytesToUuid;
      /***/
    }
    /******/
    ])
  );
});